export default{
  carousel:[
    {
      id: 0,
      text: 'Biały Bór. Woj. zachodnio-pomorskie. Poczet sztandarowy Technicznej Szkoły Rolniczej. Otwarcie Wystawy fotograficznej AK Okręg Wilno',
      img: '/srodowiska/srod_gdansk/poczet_sztandarowy_technicznej_szkoly_rolniczej.jpg'
    },
    {
      id: 1,
      text: 'Biały Bór. Woj. zachodnio-pomorskie Techniczna Szkoła Rolnicza. Wystawa fotograficzna AK Okręg Wilno',
      img: '/srodowiska/srod_gdansk/techniczna_szkola_rolnicza.jpg'
    },
    {
      id: 2,
      text: 'Szkoła im. Armii Krajowej w Gdańsku Morenie.Otwarcie konkursu przez panią dyr. mgr Niekrasz.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_3.jpg'
    },
    {
      id: 3,
      text: 'Szkoła im. Armii Krajowej w Gdańsku Morenie. Konkurs „Co wiem o AK Okręg Wilno”',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_4.jpg'
    },
    {
      id: 4,
      text: 'Szkoła im. Armii Krajowej w Gdańsku Morenie. Konkurs „Co wiem o AK Okręg Wilno”',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_5.jpg'
    },
    {
      id: 5,
      text: 'Gimnazjum Zespołu Szkół Nr2 w Wejherowie. Konkurs „Co wiem o AK Okręgu Wilno”. Komisja ocen od lewej: Romuald Łucewicz, Regina Klima, Janusz Bohdanowicz, Zofia Zygmuntowicz, Longina Koleśnik.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_6.jpg'
    },
    {
      id: 6,
      text: 'Gimnazjum Zespołu Szkół Nr2 w Wejherowie. Konkurs „Co wiem o AK Okręgu Wilno” Dyrektorka Gimnazjum mgr Bożena Kowalska wręcza dyplomy.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_7.jpg'
    },
    {
      id: 7,
      text: 'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. Konkurs „Co wiem o AK Okręgu Wilno”',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_8.jpg'
    },
    {
      id: 8,
      text: 'Gimnazjum Sportowe w Gdańsku Oliwie. Konkurs „Co wiem o AK Okręg Wilno”. Komisja ocen: Regina Klima, Zofia Zygmuntowicz, Longina Koleśnik Janusz Bohdanowicz.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_9.jpg'
    },
    {
      id: 9,
      text: 'Gimnazjum Sportowe w Gdańsku Oliwie. Konkurs „Co wiem o AK Okręg Wilno”. Obserwatorzy Łucja Białobłocka, Wacław Dziewulski, Stanisław Kowalski, Hipolit Alesionek i inni.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_10.jpg'
    },
    {
      id: 10,
      text: 'Gimnazjum Sportowe w Gdańsku Oliwie. Konkurs „Co wiem o AK Okręg Wilno”. Laureatki : Lilianna Krogulec, Małgorzata Sikorska, Dominika Żółtowska, Monika Borucka, Katarzyna Klimek, Gabriela Trębińska.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_11.jpg'
    },
    {
      id: 11,
      text: 'Gimnazjum nr 2 w Wejherowie Prelekcja na tle wystawy fotografii AK Okręg Wilno',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_12.jpg'
    },
    {
      id: 12,
      text: 'Eksponowana w szkołach w Gdańsku i Wejherowie. Wystawa fotograficzna „Katyń w dokumentach”.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_13.jpg'
    },
    {
      id: 13,
      text: 'Wystawa fotograficzna „Katyń w dokumentach” Eksponowana w szkołach w Gdańsku i Wejherowie',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_14.jpg'
    },
    {
      id: 14,
      text: 'Wystawa fotograficzna „Katyń w dokumentach” Eksponowana w szkołach w Gdańsku i Wejherowie',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_15.jpg'
    },
    {
      id: 15,
      text: 'Wystawa fotograficzna „Katyń w dokumentach” Eksponowana w szkołach w Gdańsku i Wejherowie',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_16.jpg'
    },
    {
      id: 16,
      text: 'Skorbuciany k/ Wilna. Cmentarz żołnierzy 7. Brygady „Wilhelma”. Apel poległych przy dźwiękach werbli i trąbki.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_17.jpg'
    },
    {
      id: 17,
      text: 'Ligojnie rej. wileński. Powitanie przez Starostę gminy Pogiry Marię Maciulewicz.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_18.jpg'
    },
    {
      id: 18,
      text: 'Ligojnie rej. wileński. Nauczyciele szkół gminy Wejherowo uczestnicy wycieczki przy ognisku.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_19.jpg'
    },
    {
      id: 19,
      text: 'Niemenczyn. Festiwal zespołów artystycznych z Wileńszczyzny pod nazwą „Polskie Kwiaty.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_20.jpg'
    },
    {
      id: 20,
      text: 'Pomaturalna Szkoła Rolnicza w Białej Wace Rep. Litewska. Komisja ocen konkursu  „Poprawnego czytania w języku polskim” uczniów szkół Wileńszczyzny. Od lewej: Maria Wziątek, Longina Koleśnik, Zofia Zygmuntowicz, Antoni Kaczyński, Walentyna Treszczyńska nauczycielka z Pogir i Janusz Bohdanowicz.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_21.jpg'
    },
    {
      id: 21,
      text: 'Wilno cmentarz Rossa. Składanie kwiatów przy Mauzoleum Marszałka Polski Józefa Piłsudskiego i zapalenie zniczy na grobach żołnierzy Armii Krajowej.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_22.jpg'
    },
    {
      id: 22,
      text: 'Krawczuny. Apel poległych w miejscu walki spotkaniowej z doborowymi jednostkami wojsk niemieckich wycofującymi się z Wilna .',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_23.jpg'
    },
    {
      id: 23,
      text: 'Kolonia Wileńska. Po Apelu Poległych z trąbką i werblami.Relacja kol. Zofii Zygmuntowicz uczestniczki pierwszych pogrzebów żołnierzy poległych w walkach w dniu 6 i 7 lipca 1944 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_24.jpg'
    },
    {
      id: 24,
      text: 'Kalwaria Wileńska. Laureaci konkursu historycznego przy grobach żołnierzy Armii Krajowej poległych w walkach z Wermachtem pod Krawczunami.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_25.jpg'
    },
    {
      id: 25,
      text: 'Sorok Tatary. Przed wejściem do meczetu. Spotkanie z przewodniczącym gminy tatarskiej.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_26.jpg'
    },
    {
      id: 26,
      text: 'Gimnazjum Sportowe w Gdańsku Oliwie.Konkurs „Co wiem o AK Okręg Wilno”. Fragment dekoracji sali.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_27.jpg'
    },
    {
      id: 27,
      text: 'Gimnazjum Sportowe w Gdańsku Oliwie.Konkurs „Co wiem o AK Okręg Wilno”. Uczniowie wykonawcy części artystycznej.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_28.jpg'
    },
    {
      id: 28,
      text: 'Gimnazjum Zespołu Szkół Nr 2w Wejherowie. Konkurs H. Sienkiewicz i Jego twórczość. Komisja ocen od lewej: Regina Klima, Janusz Bohdanowicz i Longina Koleśnik.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_29.jpg'
    },
    {
      id: 29,
      text: '',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_30.jpg'
    },
    {
      id: 30,
      text: 'Gimnazjum Samorządowe Gminy Wejherowo w Bolszewie. Fragment dekoracji sceny, części artystycznej finału konkursu „Co wiem o AK Okręg Wilno”.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_31.jpg'
    },
    {
      id: 31,
      text: 'Gimnazjum Zespołu Szkół Nr 3 w Wejherowie. Konkurs "Co wiem o AK Okręg Wilno". Dekoracja sali finału konkursu.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_32.jpg'
    },
    {
      id: 32,
      text: 'Pomaturalna Szkoła Rolnicza. Biała Waka.Uczestnicy konkursu „Poprawnego czytania w języku polskim”',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_33.jpg'
    },
    {
      id: 33,
      text: 'Pomaturalna Szkoła Rolnicza. Biała Waka. Konkurs „Poprawnego czytania w języku polskim” Komisja ocen od lewej : Aldona Klarska, Maria Wziątek, Longina Koleśnik, Zofia Zygmuntowicz, Zdzisław Zygmuntowicz, Janusz Bohdanowicz.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_34.jpg'
    },
    {
      id: 34,
      text: 'Gimnazjum Zespołu Szkół im. Armii Krajowej w Gdańsku Morenie. Laureatki: Kamila Oleszek i Agata Bielecka w Wilnie',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_35.jpg'
    },
    {
      id: 35,
      text: 'Laureaci Konkursów AK-owskiech ze szkół gdańskich i wejherowskich wizytą u księdza proboszcza Kolonii Wileńskiej Aloizego Koncziusa.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_36.jpg'
    },
    {
      id: 36,
      text: 'Laureatki konkursu AK-owskiego ze Szkoły im. Armii Krajowej i członkowie Komisji ocen w Trokach',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_37.jpg'
    },
    {
      id: 37,
      text: 'Wilno. Październik 2000 r. kościół pw. Św. Piotra i Pawła. Nauczyciele i laureaci konkursów historycznych.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_38.jpg'
    },
    {
      id: 38,
      text: 'Wilno. Październik 2000 r. kościół pw. Św. Piotra i Pawła. Nauczyciele i laureaci konkursów historycznych.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_39.jpg'
    },
    {
      id: 39,
      text: 'Wilno Mauzoleum Marszałka Piłsudskiego.Maj 2000 r. Laureaci konkursów historycznych z kombatantami.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_40.jpg'
    },
    {
      id: 40,
      text: 'Rudniki. Maj 2000 r. Spotkanie z żołnierzem 7. Brygady „Wilhelma” Witoldem Aładowiczem.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_41.jpg'
    },
    {
      id: 41,
      text: 'Kalwaria Wileńska. Maj 2000 r. Zbiorowa mogiła żołnierzy poległych w walce z Wermachtem pod Krawczunami 13 lipca 1944 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_42.jpg'
    },
    {
      id: 42,
      text: 'Wilkiszki uczestnicy wycieczki. Szpital partyzancki 3. Brygady „Szczerbca” laureaci konkursów i kombatanci.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_43.jpg'
    },
    {
      id: 43,
      text: 'Troki. Maj 2000 r. Laureaci konkursów historycznych z kombatantami.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_44.jpg'
    },
    {
      id: 44,
      text: 'Kalwaria Wileńska. Maj 2002 r. Zbiorowa mogiła żołnierzy poległych w walce z Wermachtem pod Krawczunami 13 lipca 1944 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_45.jpg'
    },
    {
      id: 45,
      text: 'Wilno Mauzoleum Marszałka Piłsudskiego. Maj 2004 r. Laureaci konkursów historycznych z kombatantami.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_46.jpg'
    },
    {
      id: 46,
      text: 'Troki. Maj 2004 r. Laureaci konkursów historycznych z kombatantami zwiedzają zamek najeziorny.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_47.jpg'
    },
    {
      id: 47,
      text: 'Kolonia Wileńska. Lipiec 2004. Uczestnicy wyjazdu w miejscu przekraczania rzeki Wilenki w ataku na Belmont 8 lipca 1944 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_48.jpg'
    },
    {
      id: 48,
      text: 'Bogusze. Lipiec 2004 r. Odsłonięcie pomnika w miejscu aresztowania oficerów Armii Krajowej przez NKWG w dniu 18 lipca 1944 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_49.jpg'
    },
    {
      id: 49,
      text: 'Krawczuny. Lipiec 2004 r. Uroczystości rocznicowe walk Armii Krajowej z Wermachtem 13.07.1944 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_50.jpg'
    },
    {
      id: 50,
      text: 'Kolonia Wileńska. Lipiec 2004 r. Apel poległych w walkach o Wilno 8 lipca 1944 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_51.jpg'
    },
    {
      id: 51,
      text: 'Pikiliszki. Lipiec 2004. Dworek Marszałka Józefa Piłsudskiego, w którym był po raz ostatni w 1933 r.',
      img: '/srodowiska/srod_gdansk/foto_konkursy_srod_gdansk_52.jpg'
    }
  ],
  videos:[
    {
      id: 0,
      text: 'Obchody 50-tej rocznicy walk o Wilno Sopot-Borodziej 13 lipca 1994r. (fragment)',
      url: "https://www.youtube.com/embed/EKc5JqcyFtM"
    },
    {
      id: 1,
      text: 'Uroczyste odsłonięcie i poświęcenie tablicy epitafialnej dowódcy okręgu Wileńskiego Armii Krajowej Gen. A. Rzyżanowskiego w Wrocławiu (fragment)',
      url: "https://www.youtube.com/embed/doi5DgIuJAk"
    },
    {
      id: 2,
      text: 'Chór środowiska Wileńskiego we Wrocławiu śpiewa piosenki partyzanckie (fragment)',
      url: "https://www.youtube.com/embed/GA4vplL7zDc"
    }
  ],
  lists:{
    konkurs:[
      'Pomaturalna Wileńska Szkoła Rolnicza. Biała Waka 15 maja 1999 r.',
      'Gimnazjum im. Armii Krajowej. Gdańsk Morene 15 kwietnia 2000 r.',
      'Pomaturalna Wileńska Szkoła Rolnicza Biała Waka. 3 maja 2000 r.',
      'Gimnazjum Zespołu Szkół Nr 3 w Wejherowie. 19 maja 2000 r.',
      'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. 27 października 2000 r.',
      'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. 9 kwietnia 2001 r.',
      'Gimnazjum Samorządowe w Bolszewie. 25 kwietnia 2001 r.',
      'Gimnazjalnego Nr 17 Gdańsk Oliwa. 10 maja 2001 r.',
      'Zespół Szkół Rolniczo-Ekonomicznych w Bytowie. 21 stycznia 2002 r.',
      'Gimnazjum Zespołu Szkół Nr 2 w Wejherowie. 10 kwietnia 2002 r.',
      'Gimnazjalnego Nr 17 Gdańsk Oliwa. 24 kwietnia 2002 r.',
      'Gimnazjum Nr 3 Gdańsk Chełm. 9 maja 2002 r.',
      'Gimnazjum Samorządowe w Bolszewie. 18 maja 2002 r.',
      'Szkoła w Bezdanach. 4-te klasy podstawowe',
      'Gimnazjum Samorządowe w Bolszewie. Sympozjum historyczne. 5 maja 2003 r.',
      'Liceum Nr 1 im. Króla Jana III Sobieskiego w Wejherowie. 12 maja 2003 r.',
      'Szkoła w Turgielach. 4-te klasy podstawowe. 28 maja 2003 r.',
      'Gimnazjum Samorządowe w Bolszewie. 05 kwietnia 2004 r.',
      'Gimnazjum Samorządowe w Bolszewie. 19 kwietna 2004 r.',
      'Gimnazjum Publiczne im. „Ofiar Katynia” w Piątnicy. 28 maja 2004 r.',
      'Samorządowe Gimnazjum w Bolszewie. 25 maja 2005 r.',
      'Samorządowe Gimnazjum w Bolszewie. 20 maja 2005 r.',
      'Zespół Szkół Ogólnokształcących Nr 2 w Lęborku. 22 czerwca 2005 r.'
    ],
    wystawy:[
      'Gdańsk sala Domu Architekta od 03 - 21.07. 1989 r.',
      'Gdańsk EMPiK Długi Targ od 01- 15. 08. 1989 r.',
      'Gdańsk Wrzeszcz sala SD ul. Sobótki od 01 - 23.09. 1989 r.',
      'Toruń Biblioteka UMK od 22. 11.1989 r. do 05.01.1990 r.',
      'Bydgoszcz EMPiK od 15 - 27. 01. 1990 r.',
      'Białystok sala Urzędu miasta od 13. 02. do 18.04. 1990 r.',
      'Legnica w kościele od 07 - 21.07.1990 r.',
      'Opole Muzeum Miasta od 23. 08. do 15.11.1990 r.',
      'Nysa Muzeum Miasta luty i marzec 1991. r.',
      'Szczecin Sala Wystawowa od 15. 05. do 20.06.1991 r.',
      'Gorzów Wlkp. Sala Wystaw Stow. „PAX” 16.06. do 27. 07. 1991 r.',
      'Piła Sala Wystawowa od 26. 09. do 7. 10. 1991 r.',
      'Wrocław Sala Szkoły Oficerskiej od 11- 19. 11. 1991 r.',
      'Gdańsk Koluszki Szkoła Podstawowa 10 - 17. 04. 1992 r.',
      'Gdańsk Wrzeszcz Gimnazjum Nr 7. od 02 - 09. 05. 1992 r.',
      'Szczecin w Zamku od 01-31. 08. 1994 r.',
      'Wejherowo Muzeum Przebendowskich od 21. 09. do 15. 10. 1996 r.',
      'Bielsko Biała Gimnazjum od 01-28.02. 1997 r.',
      'Warszawa Biblioteka Wojska Polskiego od 01-31.07.1998 r.',
      'Słupsk Sala Związku Solidarność od 01-31.05. 1999 r.',
      'Bytów Muzeum Kaszubskie od 01-31.10. 1999 r.',
      'Biały Bór woj. Zach. Pomorskie. Średnia Szkoła Rol. 12 - 17.01.2000 r.',
      'Gdańsk Morena Szkoła im. AK od 29. 02. do 15. 03.2000 r.',
      'Wejherowo Zespół Szkół Nr 3. od 19 - 29.05.2000 r.',
      'Wejherowo Zespół Szkół Nr 2. od 27.10. do 08.11.2000 r.',
      'Samorządowe Gimnazjum w Bolszewie w 2002 i 2003 r. -3 razy.'
    ],
    biblioteki:[
      'Biblioteka Główna Akademii Medycznej ul Parkowa Nr 1/3 51-616 WROCŁAW',
      'Biblioteka Gł. Politechniki Warszawskiej Pl. Politechniki Nr 1, WARSZAWA',
      'Biblioteka Główna SGGW ul. Nowoursynowska Nr 166, 02-6975 WARSZAWA',
      'Biblioteka Gł. Politechniki Szczecińskiej ul. Piastów Nr 17, 73-122 SZCZECIN',
      'Biblioteka Główna Akademii Medycznej ul. Rybacka 1, 70-204 SZCZECIN',
      'Biblioteka Główna Akademii Rolniczej ul. Janosika 8, 70-204 SZCZECIN',
      'Biblioteka Gł. Akademii Wych. Fizycznego ul. Czyżweskiego 29, GDAŃSK',
      'Biblio. Gł. Uniwersytetu Szczecińskiego ul. Jedn. Narodowej 22 A, 70-413 SZCZECIN',
      'Biblio. Gł. Uniwersytetu Warm. Mazur. ul. Michała Oczapowskiego 4, 10-719 OLSZTYN',
      'Biblioteka Gł. Akademii Medycznej ul. Oczki Nr 1, 00-071 WARSZAWA',
      'Biblioteka Główna AWF ul. Marymoncka Nr 34, 00-913 WARSZAWA',
      'Bib. Gł. Akademii Wych. Fizycznego ul. Mickiewicza 98, 51-684 WROCŁAW',
      'Bib. Gł. Politechniki Gdańskiej ul. Narutowicza Nr 11/12, 80-952 GDAŃSK',
      'Bib. Główna Uniwersytetu Gdańskiego ul. Armii Krajowej Nr 110, SOPOT',
      'Bib. Gł. Wyższej Szkoły Oficerskiej. Czajkowskiego 109 51-150WROCŁAW',
      'Bib. Gł. Wyższej Szkoły Wojskowej ul. Kaliskiego Nr 1, 01-747 WARSZAWA',
      'Biblioteka Katolickiego Uniwersytetu Lubelskiego ul. Szopena, LUBLIN',
      'Bib. Parafialna przy kościele pw. Najświętszego Serca Pana Jezusa, GDAŃSK',
      'Bib. Muzeum Narodowe Pl. Powstańców Warszawy Nr 5, 50- 153 WROCŁAW',
      'Bib. Gł. Politechniki Wrocławskiej i NOT Wybrzeże Wyspiańskiego 27, 50-370 WROCŁAW',
      'Bib. Szkoły Głównej Handlowej ul. Rakowiecka 22B, 02-521 WARSZAWA',
      'Biblioteka Uniwersytetu im. Mikołaja Kopernik TORUŃ',
      'Bib. Uniwersytecka im. A. Mickiewicza ul. Ratajczaka 38/40, POZNAŃ',
      'Biblioteka Uniwersytecka w Łodzi ul. Jana Matejki Nr 34/38, 90-237 ŁÓDŹ',
      'Biblioteka Uniwersytecka ul. Dobra Nr 56/60, 00-312 WARSZAWA',
      'Bib. Uniwersytet Wrocławski ul. Szajnochy Nr 7/10, 50-76 WROCŁAW',
      'Bib. Fundacja Zakład Narodowy im. Ossolińskich ul. Szewska Nr 37, 50-139 WROCŁAW',
      'Biblioteka Kapitulna ul. Kanonia Nr 12, 50-528 WROCŁAW',
      'Centralna Biblioteka Wojskowa ul. Ostrobramska Nr 109, 04-41 WARSZAWA',
      'IPN Oddział Gdański ul. Witomińska Nr 19, 81-311 GDYNIA',
      'Instytut Pamięci Narodowej Oddz. Bydgoszcz, BYDGOSZCZ',
      'Akademia Świętokrzyska w Kielcach. Filia w Piotrkowie Trybunalskim, ul. Słowackiego Nr 114/11, PIOTRKÓW TRYBUNALSKI',
      'Biblioteka Główna Akademii Medycznej ul. Debinki Nr 1, GDAŃSK',
      'Biblioteka Główna Uniwersytetu Marii Curie Skłodowskiej, LUBLIN',
      'Publiczna Biblioteka Pedagogiczna Al. Niepodległości Nr.34, 61-714 POZNAŃ'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/models/srodowiska/srod_gdansk.js